module.exports = __webpack_public_path__ + "static/media/nuvens.86f43330.jpg";